import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import { compose, mdsWidget } from 'dojo/_base/declare';
import FinderBaseV2 from '../FinderBase/FinderBaseV2';
import eFormEditor from './eFormEditor';
import { FinderTypes } from "../FinderBase/FinderBaseTypes";
import { UrlHelpers } from "../../more/Helpers";
class eFormsHome extends compose(FinderBaseV2) {

    //templateString = template;

    tableContainer: HTMLElement; // will be passed as a function parameter

    private table_formatterFunction(cell: StaticTable.StaticTableCell<any>) {

        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;

        switch (colName) {

            case "details":
            case "actions":
                // hier button einbauen
                var btn = this.UiModder.domConstruct.create("BUTTON", {
                    "class": "mds-button-base round tertiaryBG mds-hover-bright",
                    "onclick": lang.hitch(this, this.openForm, cell.entity)
                }, node);


                this.UiModder.domConstruct.create("I", { "class": "fas fa-search-plus" }, btn, "first");
                return true;
                break;

            default:
                return false;
        }
    }
    // -------------------------------------- METHODS -----------------------------------------------
    // Events handlers--------------------------------------------------START

    private _onDetailsButton_click(cell: StaticTable.StaticTableCell<eFormsTypes.eFormEntity>, evt: MouseEvent): void {

        this.openForm(cell.entity);
    }

    openForm(entity?: eFormsTypes.eFormEntity | string): void {

        let label = "General_New";
        
        let eform = new eFormEditor();
        if (typeof (entity) == "string") {
            eform.entityID = entity;
            label = "General_Loading";
            eform.entityID = entity;
        }
        else if (!!entity) {
            label = entity.$Displayname;
            eform.entityID = entity.ID;
        }
        eform.show("dlg", label, this.getTabContainerName());

        on(eform, "saved", lang.hitch(this, this.reload));
        on(eform, "requestEForm", lang.hitch(this, this._onRequestEForm));
        
        eform.startup();
    }

    private _onRequestEForm(targetID: string) {
        if (targetID) {
            this.openForm(targetID);
        }
    }
   
    private createNew(): void {
        this.openForm();
    }

    private _onClick_Row(row: StaticTable.StaticTableRow<eFormsTypes.eFormEntity>, group: any, evt: MouseEvent) {
        //console.debug("_onClick_Row", rowLine, rowGroup.entity, evt);
        this.openForm(row.rowGroup.entity);
    }

    

    private _onEntitySaved() {
        this.getFilterlist(1);
    }

    _onEmbedding() {
        super._onEmbedding.apply(this, arguments as any);
    }

    // --------------------own methods ----------------------------end
    protected _customFinderSetupConfig: Partial<FinderTypes.FinderSetupConfig> = null;
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        //this.setEntitylistPropertyName("entities");

        let config: FinderTypes.FinderSetupConfig = {
            configUrl: null,
            configCallfunction: "Webtool_eForms_API__GetFilterOptions",
            filterdataUrl: null,
            filterdataCallfunction: "Webtool_eForms_API__LoadEformsList",
            rowClickFunction: lang.hitch(this, this._onClick_Row),
            tableFormatterFunction: lang.hitch(this, this.table_formatterFunction),
            newEntryParams: {
                neededUserRole: null,
                callback: lang.hitch(this, this.createNew)
            },
        };

        if (this._customFinderSetupConfig) {
            for (let key in this._customFinderSetupConfig) {
                config[key] = this._customFinderSetupConfig[key];
            }
        }

        this.finderSetup(config);

        //this.table.addDefaultRowActionButton("view", lang.hitch(this, this._onDetailsButton_click));

    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.RequestManager.handleAs = "json";

        
        let createVal = UrlHelpers.getUrlParameterValue("create");
        let viewVal = UrlHelpers.getUrlParameterValue("view");
        if (createVal) {
            UrlHelpers.setUrlParameter("ctype", createVal);
            UrlHelpers.removeUrlParameter("create");
            this.createNew(); // Problem: wenn es noch eine Instanz von Home gibt, führt diese das jetzt auch aus
        } else if (viewVal) {
            UrlHelpers.removeUrlParameter("view");

            this.openForm(viewVal);
        }

    }
}

export default mdsWidget(eFormsHome);